<template>
  <b-field grouped>
    <b-field expanded :label="label">
      <b-field>
        <p class="control">
          <span class="button is-static">+91</span>
        </p>
        <b-input
          :value="justPhoneNumber"
          :placeholder="placeholder"
          type="text"
          expanded
          :disabled="disabled"
          @input="inputEventHandler"
        ></b-input>
      </b-field>
    </b-field>
  </b-field>
</template>

<script>
export default {
  props: {
    value: { type: String, default: '' },
    disabled: Boolean,
    label: { type: String, default: 'Phone Number:' },
    placeholder: { type: String, default: 'Enter Phone Number' }
  },
  computed: {
    justPhoneNumber() {
      return this.value && this.value.substring(3);
    }
  },
  methods: {
    inputEventHandler(value) {
      this.$emit('input', value ? '+91' + value : null);
    }
  }
};
</script>

<style></style>
